import React, {Component} from 'react';
import Styles from './style.css';
import HeaderSignupTwo from "../../components/header-signup-two/component";
import {BeatLoader} from 'react-spinners';
import InputMask from 'react-input-mask';
import cx from "classnames";
import {langRegister} from "../../services/langRegister";
import {dataRegister} from "../../services/dataRegister";
import {userRegister} from "../../services/userRegister";
import {cartRegister} from "../../services/cartRegister";
import countryCodes from "country-telephone-data";
import ReactGA from "react-ga";
import ReactGA4 from 'react-ga4';
import ReactPixel from "react-facebook-pixel";
import {campaignRegister} from "../../services/campaignRegister";
import {salesChannelRegister} from "../../services/salesChannelRegister";
import ErrorHandler from "../../components/error-handler/component";
import queryString from "query-string";
import {injectStripe, CardNumberElement, CardExpiryElement, CardCVCElement} from 'react-stripe-elements';
import ModalCoupon from "../../components/modal-coupon/component";
import {videoRegister} from "../../services/videoRegister";
import {carouselRegister} from "../../services/carouselRegister";

class SignupPayment extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            landingpage: true,
            show_phone: false,
            register: false,
            payment_methods: [],
            interface_lang: {},
            form_validation: {},
            lockin_plan: {},
            first_name: "",
            last_name: "",
            email: "",
            password: "",
            company_name: "",
            website: "",
            phone: "",
            card_number: "",
            card_month: "",
            card_year: "",
            card_ccv: "",
            send_to: "",
            autocomplete_predictions: [],
            autocomplete_search: "",
            logged_in: false,
            admin: false,
            lockin: false,
            pay_now: true,
            currency: null,
            card_error: {
                number: false,
                expiry: false,
                cvc: false,
                show: false,
                message: ""
            },
            secure_payment: false,
            secure_payment_ur: "",
            landing_address: "",
            landing_address_id: "",
            landing_email: "",
            landing_website: "",
            lat: null,
            lng: null,
            countries: [],
            country: null,
            dropdown: false,
            search: "",
            address: "",
            campaign: null,
            service_fee_fixed: null,
            service_fee_percentage: null,
            redirect_email: "",
            redirect: false,
            user_email: "",
            reseller: false,
            whatsapp: false,
            system_error: false,
            user_error: false,
            admin_image: false,
            greetings_invoice: false,
            greetings_invoice_profileimage: false,
            branding: false
        };
        this.google = window.google;
        this.functions.setCouponModal = this.functions.setCouponModal.bind(this);
        this.functions.facebookCallBack = this.functions.facebookCallBack.bind(this);
    };

    componentWillMount() {
        window.scrollTo(0, 0);

        this.update.user();
        this.update.data();
        this.update.countries();

        //GOOGLE ANALYTICS
        if (dataRegister.api.primehit !== "https://api.devprimehit.com/v1") {
            ReactGA.pageview('/signup/payment');
            ReactGA4.send({ hitType: "pageview", page: "/signup/payment" });
        }

        //FACEBOOK PIXEL
        if(dataRegister.api.primehit !== "https://api.devprimehit.com/v1"){
            ReactPixel.pageView();
        }

    }

    componentDidMount() {
        this.update.stripe();
        try {
            this.autocomplete = new this.google.maps.places.AutocompleteService();
        } catch (e) {
        }
        try {
            this.geocoder = new this.google.maps.Geocoder;
        } catch (e) {}

        window.fbAsyncInit = function() {
            window.FB.init({
                appId      : '1023606744646481',
                xfbml      : true,
                version    : 'v4.0',
                display    : 'page',
                redirect_uri: 'https://devsaleschannel.com/' + salesChannelRegister.get('market') + '/' + langRegister.lang() + "/" + salesChannelRegister.get('name') + '/signup/payment'
            });
            window.FB.AppEvents.logPageView();
        }.bind(this);

        (function(d, s, id){
            var js, fjs = d.getElementsByTagName(s)[0];
            if (d.getElementById(id)) {return;}
            js = d.createElement(s); js.id = id;
            js.src = "https://connect.facebook.net/en_US/sdk.js";
            fjs.parentNode.insertBefore(js, fjs);
        }(document, 'script', 'facebook-jssdk'));

    }

    update = {
        data: () => {
            let stored_data = cartRegister.get();
            if (stored_data.admin_image) {
                if (!stored_data.admin_image.data_url && !stored_data.admin_image.web_url) {
                    this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/" + salesChannelRegister.get('name') + "/signup/image");
                }
            }
            if (stored_data.budget && stored_data.regions && stored_data.industry && stored_data.channels && (stored_data.image || stored_data.admin_image) && (stored_data.quotes || stored_data.admin_quotes) && stored_data.plan) {
                if (stored_data.regions.length < 1) {
                    this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/" + salesChannelRegister.get('name') + "/signup/image")
                } else {
                    this.setState({
                        industry: stored_data.industry,
                        market: salesChannelRegister.get('market'),
                        currency: salesChannelRegister.get('currency'),
                        vat: salesChannelRegister.get('vat'),
                        budget: stored_data.budget,
                        channels: stored_data.channels,
                        lockin: stored_data.lockin,
                        lockin_plan: stored_data.lockin_plan,
                        duration: stored_data.duration,
                        related: stored_data.related_industries ? stored_data.related_industries : [],
                        plan: stored_data.plan,
                        company_name: stored_data.company_name,
                        company_location: stored_data.company_location,
                        targets: stored_data.targets ? stored_data.targets : [],
                        age_range: stored_data.age_range ? stored_data.age_range : [],
                        service_fee_percentage: stored_data.servicefee_percentage,
                        service_fee_fixed: stored_data.servicefee_fixed,
                    }, () => {

                        try {
                            if (stored_data.admin_image.data_url) {
                                this.setState({admin_image_file: this.functions.dataURItoBlob(stored_data.admin_image.data_url)}, () => {
                                    console.log(this.state.admin_image_file);
                                });
                            }
                        } catch (e) {
                        }

                        //SET LOCATION
                        try {
                            let self = this;
                            if (this.state.company_location) {
                                this.autocomplete.getPlacePredictions({
                                    input: this._renderName(this.state.company_location),
                                    componentRestrictions: {country: salesChannelRegister.get('market')}
                                }, function (predictions, status) {
                                    if (status === 'OK' && predictions && predictions.length > 0) {
                                        self.geocoder.geocode({'placeId': predictions[0].place_id}, function (results, status) {
                                            if (status === 'OK' && results && results.length > 0) {
                                                try {
                                                    if (results[0].geometry && predictions[0].description) {
                                                        self.setState({
                                                            lat: results[0].geometry.location.lat(),
                                                            lng: results[0].geometry.location.lng(),
                                                            autocomplete_search: predictions[0].description,
                                                            landing_address: predictions[0].description
                                                        }, () => {
                                                        });
                                                    }
                                                } catch (e) {
                                                }
                                            } else {
                                                self.setState({
                                                    autocomplete_dropdown: false,
                                                    autocomplete_predictions: []
                                                })
                                            }
                                        });
                                    } else {

                                    }
                                });
                            }
                        } catch (e) {
                        }


                    });
                }
            } else {
                this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/" + salesChannelRegister.get('name') + "/signup/image")
            }
        },
        stripe: () => {
            try {
                window.stripe_api = window.Stripe(dataRegister.stripe_key);
                var elements = window.stripe_api.elements();
                var style = {
                    base: {
                        color: '#000000',
                        fontFamily: 'sans-serif',
                        lineHeight: '2.1',
                        fontSmoothing: 'antialiased',
                        fontSize: '15px',
                        '::placeholder': {
                            color: '#808080'
                        }
                    },
                    invalid: {
                        color: '#000000'
                    }
                };
                window.cardNumber = elements.create('cardNumber', {
                    style: style
                });
                window.cardNumber.mount('#card-number');
                window.cardExpiry = elements.create('cardExpiry', {
                    style: style
                });
                window.cardExpiry.mount('#card-expiry');
                window.cardCvc = elements.create('cardCvc', {
                    style: style
                });
                window.cardCvc.mount('#card-cvc');
            } catch (e) {
                this.setState({system_error: true});
            }
        },
        user: () => {
            let user = userRegister.get();
            console.log(user);
            if (user) {
                this.setState({
                    logged_in: true,
                    user_email: user.email,
                    user_phone: user.phone,
                    user_name: user.name,
                    user_image: user.profile_image,
                    reseller: user.reseller || user.inhouse,
                    inhouse: user.inhouse,
                    user: user
                });
            }

            if (user && user.socialData && user.socialData.branding) {
                this.setState({
                    branding: true,
                    landingpage: false
                });
            }
        },
        countries: () => {
            let countries = JSON.parse(JSON.stringify(countryCodes.allCountries));
            for (let i = 0; i < countries.length; i++) {
                countries[i].dialCode = "+" + countries[i].dialCode;
                if (countries[i].iso2 === salesChannelRegister.get('market')) {
                    this._selectCountry(countries[i]);
                }
            }
            this.setState({countries: countries});
        },
        campaign: (token) => {
            let cart = cartRegister.get();
            let campaign = {};
            campaign.free_website = this.state.landingpage;
            if (langRegister.lang()) {
                campaign.lang = langRegister.lang();
            }
            if (cart.duration) {
                campaign.campaign_duration = cart.duration;
            }

            //PRIVATE STRATEGY
            if(cart.strategy){
                try {
                    if(cart.strategy.private){
                        campaign.private_industry_strategy_id = cart.strategy.id;
                    }
                }catch (e) {}
            }

            //GREETINGS
            if(this.state.reseller && !this.state.pay_now && this.state.greetings_invoice && this.state.redirect){
                campaign.greetings_invoice = {
                    profile_image: this.state.greetings_invoice_profileimage,
                    name: true
                };
                campaign.greetings_invoice = JSON.stringify(campaign.greetings_invoice);
            }

            //SET AUTO RENEW TO FALSE
            if(!this.state.pay_now){
                campaign.auto_renew = false;
            }

            //SET SMART SPEND
            campaign.smart_spend = cart.smart_spend;
            //console.log(campaign.smart_spend + " SMART SPEND");

            //SET CAROUSEL ADS
            if (carouselRegister.get()) {
                try {
                    let slides = carouselRegister.get();
                    let carousel_ads = [];
                    for (let i = 0; i < slides.length; i++) {
                        let slide = {
                            image: slides[i],
                            title: this.state.industry.name,
                            description: this.state.company_location.name
                        };
                        carousel_ads.push(slide);
                    }
                    campaign.carousel_ads = JSON.stringify(carousel_ads);
                } catch (e) {
                }
            }

            console.log(campaign.carousel_ads);

            if(cart.admin_slideshow_images){
                if(cart.admin_slideshow_images.filter((item) => {
                    return item.selected
                }).length > 0){
                    let custom_slides = cart.admin_slideshow_images.filter((item) => {
                        try{
                            return item.images.small && item.selected;
                        }catch (e) {
                            return false
                        }
                    }).sort((a, b) => (a.number > b.number) ? 1 : -1).map((item) => {
                        return {
                            image: item.images.small,
                            title: this.state.industry.name,
                            description: this.state.company_location.name
                        };
                    });
                    campaign.carousel_ads = JSON.stringify(custom_slides);
                }
            }

            //console.log(campaign.carousel_ads);

            //SET VIDEO
            if(cart.admin_video && cart.admin_video_thumbnail){
                try {
                    let video = videoRegister.get();
                    campaign.video = JSON.stringify({url: cart.admin_video, thumbnail: cart.admin_video_thumbnail});
                } catch (e) {}
            } else if (videoRegister.get()) {
                try {
                    let video = videoRegister.get();
                    campaign.video = JSON.stringify({url: video.url, thumbnail: video.thumbnail});
                } catch (e) {
                }
            }

            //IF COUPON CODE
            if (this.state.coupon_success) {
                campaign.coupon_code = this.state.coupon;
            }

            //SET AD REGION
            try {
                if (this.state.company_location) {
                    campaign.ad_region = this.state.company_location.name;
                }
            } catch (e) {
            }

            //SET REGION LONGTAIL
            try {
                if (this.state.company_location) {
                    campaign.longtail_region = this.state.company_location.id;
                }
            } catch (e) {
            }

            //SET KEYWORD_LANGUAGES
            try {
                let langs = {
                    google: cart.keyword_languages,
                    bing: cart.keyword_languages
                };
                campaign.additional_keyword_languages = JSON.stringify(langs);
            } catch (e) {
            }

            if (campaign.free_website) {
                campaign.free_website_data = {};
            }
            if (cart.age_range || cart.targets || cart.interests || cart.behaviors) {
                campaign.facebook_demographics = {};
            }
            if (this.state.company_name) {
                campaign.advertise_name = this.state.company_name;
            }
            if (this.state.website) {
                campaign.advertise_website = this.state.website;
            }
            if (this.state.pay_now) {
                campaign.card_token = token;
            }
            if (cart.industry) {
                campaign.industry = cart.industry.id;
            }
            if (this.state.phone) {
                let country_code = null;
                try {
                    country_code = this.state.country.dialCode;
                } catch (e) {
                }
                campaign.advertise_phone = this.state.phone;
                if (country_code) {
                    campaign.advertise_phone = country_code + campaign.advertise_phone;
                }
            }
            if (cart.regions) {
                campaign.region = {};
                for (let i = 0; i < cart.regions.length; i++) {
                    campaign.region[i] = cart.regions[i].id;
                }
            }
            if (cart.image && !cart.admin_image) {
                campaign.image_id = cart.image.id
            }
            if (cart.admin_image) {
                campaign.file = this.state.admin_image_file;
            }
            if (cart.channels && cart.budget) {
                campaign.offer = {};
                campaign.channels = {};
                for (let key in cart.budget) {
                    if (cart.budget[key] && cart.channels[key].selected) {
                        if (key === "facebook") {
                            campaign.offer["fb"] = {cpc: cart.budget[key].cpc, cpi: cart.budget[key].cpi};
                            campaign.channels["fb"] = cart.budget[key].spend;
                        } else {
                            campaign.offer[key] = {cpc: cart.budget[key].cpc, cpi: cart.budget[key].cpi};
                            campaign.channels[key] = cart.budget[key].spend;
                        }
                    }
                }
            }
            if (cart.target_slogans) {
                campaign.target = {};
                for (let i = 0; i < cart.target_slogans.length; i++) {
                    if (cart.target_slogans[i].selected) {
                        //campaign.target[cart.target_slogans[i].id] = cart.target_slogans[i].id;
                        campaign.target_slogan = cart.target_slogans[i].id;
                    }
                }
            }
            if (cart.quotes && !cart.admin_quotes) {
                //CHECK IF CUSTOM QUOTE
                let custom_exist = false;
                for (var key in cart.quotes) {
                    if (cart.quotes[key].custom) {
                        custom_exist = true;
                        break;
                    }
                }
                if (custom_exist) {
                    campaign.custom_slogans = [];
                    var sortable = [];
                    for (var key in cart.quotes) {
                        sortable.push([cart.quotes[key], cart.quotes[key].index]);
                    }
                    sortable.sort(function (a, b) {
                        return a[1] - b[1];
                    });
                    sortable.map((item) => {
                        campaign.custom_slogans.push(item[0].slogan);
                    });
                } else {
                    campaign.slogans = {};
                    let index = 0;
                    var sortable = [];
                    for (var key in cart.quotes) {
                        sortable.push([cart.quotes[key], cart.quotes[key].index]);
                    }
                    sortable.sort(function (a, b) {
                        return a[1] - b[1];
                    });
                    sortable.map((item) => {
                        campaign.slogans[index] = item[0].id;
                        index++;
                    });
                }
            } else {
                campaign.custom_ad_text = cart.admin_quotes.text;
                delete campaign.slogans;
            }
            if (campaign.free_website) {
                campaign.free_website_data.email = this.state.landing_email;
                campaign.free_website_data.website = this.state.landing_website;
                campaign.free_website_data.address = this.state.landing_address;
                campaign.free_website_data.lat = this.state.lat;
                campaign.free_website_data.lng = this.state.lng;
                campaign.free_website_data.whatsapp = this.state.whatsapp;
            }
            if (cart.age_range) {
                let age_range = cart.age_range.sort(function (a, b) {
                    return a - b
                });
                if (age_range[0]) {
                    campaign.facebook_demographics.age_min = age_range[0];
                }
                if (age_range[1]) {
                    campaign.facebook_demographics.age_max = age_range[1];
                }
            }
            if (cart.targets) {
                let targets = cart.targets.filter((item) => {
                    return item.selected
                });
                if (targets.length > 0 && targets.length < 2) {
                    campaign.facebook_demographics.gender = targets[0].value;
                }
            }
            if (cart.interests) {
                try {
                    if (cart.interests.length > 0) {
                        campaign.facebook_demographics.interests = cart.interests;
                    }
                } catch (e) {
                }
            }
            if (cart.behaviors) {
                try {
                    if (cart.behaviors.length > 0) {
                        campaign.facebook_demographics.behaviors = cart.behaviors;
                    }
                } catch (e) {
                }
            }
            if (cart.related_industries || cart.extra_industries) {
                campaign.related_industries = {};
                let related_industries = cart.related_industries.filter((item) => {
                    return item.selected
                });
                if (cart.extra_industries) {
                    related_industries = related_industries.concat(cart.extra_industries);
                }
                for (let i = 0; i < related_industries.length; i++) {
                    campaign.related_industries[i] = related_industries[i].id;
                }
                campaign.related_industries = JSON.stringify(campaign.related_industries);
            }
            if (cart.lockin && cart.lockin_plan) {
                campaign.lock_in = cart.lockin_plan.months;
                campaign.free_months = cart.lockin_plan.free_months;
            }
            if (this.state.redirect) {
                campaign.email = this.state.redirect_email;
            }
            if (cart.crossroad) {
                campaign.optimization = (cart.crossroad === "instant" ? 2 : 1);
            }
            campaign.region = JSON.stringify(campaign.region);
            campaign.channels = JSON.stringify(campaign.channels);
            campaign.offer = JSON.stringify(campaign.offer);
            if (campaign.slogans) {
                campaign.slogans = JSON.stringify(campaign.slogans);
            }
            if (campaign.custom_slogans) {
                campaign.custom_slogans = JSON.stringify(campaign.custom_slogans);
            }
            if (campaign.target) {
                campaign.target = JSON.stringify(campaign.target);
            }
            if (campaign.free_website) {
                campaign.free_website_data = JSON.stringify(campaign.free_website_data);
            }
            if (campaign.facebook_demographics) {
                campaign.facebook_demographics = JSON.stringify(campaign.facebook_demographics);
            }
            return campaign;
        }
    };

    functions = {
        setLanding: () => {
            if (this.state.branding) {
            this.setState({landingpage: !this.state.landingpage, website: ""});
            }
        },
        facebookLogin: () => {
            if(this.renders.facebookPermission()){
                let self = this;
                window.FB.login(function(response) {
                    // handle the response
                    if(response.authResponse && response.status === "connected"){
                        dataRegister.saveFacebookToken(salesChannelRegister.get('market'), {token: response.authResponse.accessToken, fb_user_id: response.authResponse.userID}).then((response) => {
                            let user = userRegister.get();
                            user.show_fb_button = false;
                            userRegister.set(user);
                            self.setState({
                                user: user
                            });

                        }, (error) => {
                        });
                    }
                }, {
                    scope: 'ads_management, ads_read, business_management',
                    return_scopes: true
                })
            }
        },
        facebookCallBack: (data) => {
            console.log(data);
        },
        createUser: () => {
            this.state.form_validation.email = !this.validators.email(this.state.email);
            this.state.form_validation.password = this.state.password === "";
            if(!this.state.form_validation.email && !this.state.form_validation.password){
                this.setState({register_loader: true}, () => {
                    let user = {email: this.state.email, password: this.state.password, lang: langRegister.lang()};
                    dataRegister.signUp(salesChannelRegister.get("market"), user).then((response) => {
                        if (!response.errors) {
                            userRegister.set(response);
                            this.update.user();
                            this.setState({register_loader: false});
                        } else {
                            this.setState({register_loader: false}, () => {
                                console.log(response.errors)
                            });
                        }
                    }, (error) => {
                        try {
                            if(error.status === 400){
                                this.state.form_validation.email = true;
                                this.state.form_validation.password = true;
                                this.setState({register_loader: false, form_validation: this.state.form_validation, password: "", email: ""}, () => {
                                    console.log(error);
                                });
                            }else{
                                this.setState({system_error: true, register_loader: false}, () => {
                                    console.log(error);
                                });
                            }
                        }catch (e) {
                            this.state.form_validation.email = true;
                            this.setState({register_loader: false, form_validation: this.state.form_validation, password: "", email: ""}, () => {
                                console.log(error);
                            });
                        }
                    });
                });
            }else{
                this.setState({form_validation: this.state.form_validation});
            }
        },
        createCampaignPay: (value) => {
            //CALL API TO CREATE CAMPAIGN
            dataRegister.campaign(salesChannelRegister.get('market'), value).then((data) => {
                if (!data.errors) {
                    //SET CAMPAIGN DATA AND GO TO CONFIRMATION
                    campaignRegister.set(data);
                    this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/" + salesChannelRegister.get('name') + "/signup/confirmation");

                } else {
                    //CREATE CAMPAIGN VALUES ERROR
                    this.setState({isLoading: false}, () => {
                        console.log(data.errors);
                    });
                }
            }, (error) => {
                //CREATE CAMPAIGN API ERROR
                if (error.status === 401) {
                    this.setState({isLoading: false, error: 401}, () => {
                        console.log(error);
                    });
                } else {
                    this.setState({isLoading: false, system_error: true}, () => {
                        console.log(error);
                    });
                }
            });
        },
        createCampaignNoPay: () => {
            //ADD TO FORMDATA
            let campaign = this.update.campaign();
            const formData = new FormData();
            for (let key in campaign) {
                formData.append(key, campaign[key]);
            }
            dataRegister.campaign(salesChannelRegister.get('market'), formData).then((data) => {
                if (!data.errors) {
                    data.no_pay = true;
                    campaignRegister.set(data);
                    this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/" + salesChannelRegister.get('name') + "/signup/confirmation")
                } else {
                    this.setState({isLoading: false});
                }
            }, (error) => {
                //CREATE CAMPAIGN API ERROR
                if (error.status === 401) {
                    this.setState({isLoading: false, error: 401}, () => {
                        console.log(error);
                    });
                } else {
                    this.setState({isLoading: false, system_error: true}, () => {
                        console.log(error);
                    });
                }
            });
        },
        dataURItoBlob: (dataURI) => {
            var byteString;
            if (dataURI.split(',')[0].indexOf('base64') >= 0) {
                byteString = atob(dataURI.split(',')[1]);
            } else {
                byteString = unescape(dataURI.split(',')[1]);
            }
            var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
            var ia = new Uint8Array(byteString.length);
            for (var i = 0; i < byteString.length; i++) {
                ia[i] = byteString.charCodeAt(i);
            }
            return new Blob([ia], {type: mimeString});
        },
        reviewLanding: () => {
            let cart = JSON.parse(JSON.stringify(cartRegister.get()));
            let admin_slogan = [];
            if (cart.admin_quotes) {
                admin_slogan.push(cart.admin_quotes.text);
            }
            let extra_industries = cart.extra_industries ? cart.extra_industries : [];
            let url_object = {
                image: cart.image ? JSON.stringify({url: cart.image.url, id: cart.image.id}) : (cart.admin_image ? JSON.stringify({url: cart.admin_image.url}) : null),
                company_name: this.state.company_name,
                address: this.state.landing_address,
                lang: langRegister.lang(),
                country: salesChannelRegister.get('market'),
                lat: this.state.lat,
                lng: this.state.lng,
                phone: (this.state.country.dialCode && this.state.phone !== "") ? (this.state.country.dialCode + this.state.phone) : this.state.phone,
                email: this.state.landing_email,
                website: this.state.landing_website,
                industry: JSON.stringify(cart.industry),
                whatsapp: JSON.stringify(this.state.whatsapp),
                related_industries: JSON.stringify(cart.related_industries.filter((item) => {
                    return item.selected
                }).concat(extra_industries).map((item) => {
                    return (item)
                }).map((item) => {
                    return item.name
                })),
                slogans: !cart.admin_quotes ? (JSON.stringify(Object.keys(cart.quotes)
                    .filter((key) => {
                        return cart.quotes[key].selected
                    })
                    .sort(function (a, b) {
                        if (cart.quotes[a].index < cart.quotes[b].index) {
                            return -1;
                        }
                        if (cart.quotes[a].index > cart.quotes[b].index) {
                            return 1;
                        }
                        return 0;
                    }).map((key) => {
                        return cart.quotes[key].slogan
                    }))) : JSON.stringify(admin_slogan),
            };
            //let query = queryString.stringify(url_object);
            //window.open("https://lp."+dataRegister.getDomain()+"?"+query, '_blank');

            let query = queryString.stringify(url_object);
            let url = 'https://lp.' + dataRegister.domain;
            //let url = 'http://localhost:3001';
            var popUp = window.open(url + "?" + query, '_blank');
            try {
                if (cart.admin_image) {
                    setTimeout(() => {
                        popUp.postMessage(cart.admin_image, url);
                    }, 500)
                }
            } catch (e) {
                console.log(e);
            }

        },
        checkCoupon: () => {
            if (!this.state.isCouponLoading && this.state.coupon !== "") {
                this.setState({isCouponLoading: true}, () => {
                    dataRegister.checkCoupon(salesChannelRegister.get('market'), this.state.coupon).then((response) => {
                        try {
                            if (response.discount_amount) {
                                if (this.state.service_fee_fixed) {
                                    if (+response.discount_amount + 1 > this.calculate.exclVat() - this.calculate.fixedFee()) {
                                        this.setState({
                                            coupon_modal: true,
                                            isCouponLoading: false,
                                            coupon_success: false,
                                            discount: 0
                                        });
                                    } else {
                                        this.setState({
                                            coupon_modal: false,
                                            isCouponLoading: false,
                                            coupon_success: true,
                                            discount: Math.round(+response.discount_amount)
                                        });
                                    }
                                } else if (this.state.service_fee_percentage) {
                                    if (+response.discount_amount + 1 > this.calculate.exclVat() - this.calculate.percentageFee()) {
                                        this.setState({
                                            coupon_modal: true,
                                            isCouponLoading: false,
                                            coupon_success: false,
                                            discount: 0
                                        });
                                    } else {
                                        this.setState({
                                            coupon_modal: false,
                                            isCouponLoading: false,
                                            coupon_success: true,
                                            discount: Math.round(+response.discount_amount)
                                        });
                                    }
                                } else {
                                    if (+response.discount_amount + 1 > this.calculate.exclVat()) {
                                        this.setState({
                                            coupon_modal: true,
                                            isCouponLoading: false,
                                            coupon_success: false,
                                            discount: 0
                                        });
                                    } else {
                                        this.setState({
                                            coupon_modal: false,
                                            isCouponLoading: false,
                                            coupon_success: true,
                                            discount: Math.round(+response.discount_amount)
                                        });
                                    }
                                }
                            } else if (response.discount_percent) {
                                let amount = 0;
                                if (this.state.service_fee_fixed) {
                                    amount = (this.calculate.fixedFee() / 100) * response.discount_percent;
                                } else if (this.state.service_fee_percentage) {
                                    amount = (this.calculate.percentageFee() / 100) * response.discount_percent;
                                } else {
                                    amount = (this.calculate.exclVat() / 100) * response.discount_percent;
                                }
                                this.setState({
                                    coupon_modal: false,
                                    isCouponLoading: false,
                                    coupon_success: true,
                                    discount: Math.round(+amount)
                                });
                            }

                            /*
                            //GOOGLE EVENT
                            if(dataRegister.api.primehit !== "https://api.devprimehit.com/v1"){
                                ReactGA.event({category: 'User', action: 'Added Coupon', value: this.state.discount});
                                ReactGA4.event({category: 'User', action: 'Added Coupon', value: this.state.discount});
                            }

                            //console.log("added coupon amount: " + this.state.discount + this.state.currency);

                            //FACEBOOK EVENT
                            if(dataRegister.api.primehit !== "https://api.devprimehit.com/v1"){
                                ReactPixel.trackCustom('AddCoupon', {value: this.state.discount, currency: this.state.currency});
                            }
                            */

                        } catch (e) {
                        }
                    }, (error) => {
                        this.setState({coupon_modal: true, isCouponLoading: false, coupon_success: false, discount: 0});
                    });
                })
            }
        },
        setCouponModal: (value) => {
            this.setState({coupon_modal: value});
        }
    };

    _placement(place) {
        try {
            let cart = cartRegister.get();
            let query = {
                industry: place === 'instagram' ? this.state.industry.name : this._renderCustomIndustry(place === 'instagram'),
                region: salesChannelRegister.get("market"),
                quotes: this._renderQuotes(place === 'instagram'),
                image: cart.image ? cart.image.url : cart.admin_image.url,
                saleschannel: salesChannelRegister.get("name"),
                pageTitle: salesChannelRegister.get('socialTitle'),
                pageImage: salesChannelRegister.get('socialIcon')
            };

            if(this.state.landingpage){
                query.website = this.parsers.text("item_58") + salesChannelRegister.get("market");
            }else if(this.state.website.length < 3){
                query.website = this.parsers.text("item_57") + salesChannelRegister.get("market");
            }else{
                query.website = this.state.website;
            }

            console.log(query);

            const stringified = queryString.stringify(query);
            let url = 'https://placement.' + dataRegister.domain;
            if (dataRegister.domain === "localhost") {
                url = 'https://placement.devsaleschannel.com';
            }
            var popUp = window.open(url + "/" + langRegister.lang() + "/" + place + "?" + stringified, '_blank');

        } catch (e) {
            console.log(e);
        }
    }

    _renderCustomIndustry(instagram) {
        try {
            if (instagram) {
                return this._renderName(this.state.company_location) + " | " + this.state.company_name;
            } else {
                return this.state.industry.name.trim() + " | " + this._renderName(this.state.company_location) + " | " + this.state.company_name;
            }
        } catch (e) {
            return null;
        }
    }

    _renderName(item) {
        try {
            if (salesChannelRegister.get('default_language') !== langRegister.lang() && item.internationalname) {
                return item.internationalname;
            } else {
                return item.name
            }
        } catch (e) {
            return item.name
        }
    }

    _renderQuotes(instagram) {
        let cart = cartRegister.get();
        if (instagram) {
            let quotes_string = "";
            if (!cart.quotes.custom) {
                let i = 1;
                var sortable = [];
                for (var key in cart.quotes) {
                    sortable.push([cart.quotes[key], cart.quotes[key].index]);
                }
                sortable.sort(function (a, b) {
                    return a[1] - b[1];
                });
                sortable.map((item) => {
                    quotes_string += item[0].slogan + (sortable.length > i ? " - " : "");
                    i++;
                });

                if (this._renderCustomIndustry(instagram)) {
                    quotes_string = " | " + this._renderCustomIndustry(instagram) + " | " + quotes_string;
                }

            } else {
                quotes_string = this.state.quotes.text;
            }
            return quotes_string
        } else {
            let quotes_string = "";
            if (!cart.quotes.custom) {
                let i = 1;
                var sortable = [];
                for (var key in cart.quotes) {
                    sortable.push([cart.quotes[key], cart.quotes[key].index]);
                }
                sortable.sort(function (a, b) {
                    return a[1] - b[1];
                });
                sortable.map((item) => {
                    quotes_string += item[0].slogan + (sortable.length > i ? " - " : "");
                    i++;
                });
            } else {
                quotes_string = cart.quotes.text;
            }
            return quotes_string
        }
    }

    _payment() {
        if (!this.state.isLoading) {
            //SET ALL VALIDATORS TO FALSE
            this.state.user_error = false;
            this.state.card_error.number = false;
            this.state.card_error.expiry = false;
            this.state.card_error.cvc = false;
            this.state.card_error.show = false;
            this.state.card_error.message = "";
            for (let key in this.state.form_validation) {
                this.state.form_validation[key] = false;
            }
            if (!this.state.logged_in) {
                this.state.form_validation.email = !this.validators.email(this.state.email);
                this.state.form_validation.password = this.state.password === "";
            }
            if (this.state.redirect) {
                this.state.form_validation.redirect_email = !this.validators.email(this.state.redirect_email);
            }
            if (this.state.landingpage) {
                if (this.state.landing_website !== "") {
                    this.state.form_validation.landing_website = !this.validators.website(this.state.landing_website);
                } else {
                    this.state.form_validation.landing_website = false;
                }
                this.state.form_validation.website = false;
                this.state.form_validation.landing_address = (this.state.landing_address === "");
                this.state.form_validation.landing_email = !this.validators.email(this.state.landing_email);
            } else {
                this.state.form_validation.website = !this.validators.website(this.state.website);
            }
            this.state.form_validation.company_name = (this.state.company_name === "");


            if(!this.state.inhouse && !this.state.landingpage){
                this.state.form_validation.phone = !this.validators.phone(this.state.phone);
                try {
                    this.state.form_validation.dialcode = !this.state.country.dialCode;
                } catch (e) {
                    this.state.form_validation.dialcode = true;
                }
            }

            // ONLY SALESCHANNELDEMO FOR NOW  ---- TEMP -----
            try {
                if(this.renders.saleschanneldemo()){
                    if((this.renders.previewAds("facebook") || this.renders.previewAds("instagram")) && this.renders.facebookPermission() && this.state.pay_now){
                        this.state.form_validation.facebook_permission = true;
                    }else{
                        this.state.form_validation.facebook_permission = false;
                    }
                }
            }catch (e) {}
            // ONLY SALESCHANNELDEMO FOR NOW  ---- TEMP -----

            this.setState({
                form_validation: this.state.form_validation,
                error: false,
                card_error: this.state.card_error,
                website_error: false,
                isLoading: true
            }, () => {
                //CHECK FOR VALIDATION ERRORS
                let result = false;
                for (let key in this.state.form_validation) {
                    if (this.state.form_validation[key]) {
                        result = true;
                        break;
                    }
                }
                //IF NO VALIDATION ERRORS

                if (result) {
                    this.setState({error: true, isLoading: false});
                }else{
                    if(this.state.inhouse && (this.state.phone === "" || !this.state.phone) && !this.state.landingpage){
                        if (this.state.pay_now) {
                            this._charge()
                        } else {
                            this.functions.createCampaignNoPay();
                        }
                    }else{
                        //CHECK PHONE
                        let phone = "";
                        try{
                            phone = this.state.country.dialCode.replace('+', "");
                        }catch (e) {
                            console.log(e);
                        }
                        dataRegister.checkPhone(salesChannelRegister.get('market'), (phone + this.state.phone)).then((response) => {
                            if(response.countryCode && response.countryCode.toLowerCase() === salesChannelRegister.get('market').toLowerCase()){
                                if (this.state.pay_now) {
                                    this._charge();
                                } else {
                                    this.functions.createCampaignNoPay();
                                }
                            }else{
                                this.state.form_validation.phone = true;
                                this.setState({
                                    isLoading: false,
                                    form_validation: this.state.form_validation,
                                    error: true
                                });
                            }
                        }, (error) => {
                            this.state.form_validation.phone = true;
                            this.setState({
                                isLoading: false,
                                form_validation: this.state.form_validation,
                                error: true
                            });
                        });
                    }
                }

            });
        }
    }

    _charge() {

        let self = this;
        let Stripe = window.stripe_api;
        const paymentRequest = {
            currency: this.state.currency,
            amount: this.calculate.partialBudget() * 100
        };

        doPayment(paymentRequest);

        function doPayment(paymentRequest) {
            Stripe.createSource(window.cardNumber).then((cardResponse) => {
                if (!cardResponse.error) {
                    cardResponse = cardResponse.source;

                    if ((cardResponse.card.three_d_secure === 'not_supported' || cardResponse.card.three_d_secure === 'optional') && cardResponse.status === 'chargeable') {
                        self.setState({payment_modal: false, isLoading: true}, () => {
                            createCampaign(cardResponse.id, false);
                        });
                    } else if (cardResponse.card.three_d_secure === 'required') {
                        Stripe.createSource({
                            type: 'three_d_secure',
                            amount: paymentRequest.amount,
                            currency: paymentRequest.currency,
                            three_d_secure: {card: cardResponse.id},
                            redirect: {return_url: "https://" + dataRegister.domain + "/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/" + salesChannelRegister.get('name') + "/redirect"}
                        }).then((stripe3dsResponse) => {
                            if (!stripe3dsResponse.error) {
                                stripe3dsResponse = stripe3dsResponse.source;
                                self.setState({payment_modal: true, isLoading: false}, () => {
                                    let height = window.innerWidth > 1050 ? 700 : 300;
                                    document.querySelector('#iframe-payment').innerHTML = '<iframe scrolling="true" style="width:100%; height:' + height + 'px" frameborder="0" src="' + stripe3dsResponse.redirect.url + '"></iframe>';
                                    pollForSourceStatus(stripe3dsResponse.id, stripe3dsResponse.client_secret, true);
                                });
                            } else {
                                self.setState({isLoading: false}, () => {
                                    console.log(stripe3dsResponse);
                                });
                            }
                        })
                    }
                } else {
                    if (cardResponse.error.code === "invalid_number" || cardResponse.error.code === "incomplete_number") {
                        self.state.card_error.number = true;
                        self.state.card_error.show = true;
                        //self.state.card_error.message = cardResponse.error.message;
                    } else if (cardResponse.error.code === "invalid_expiry_year_past" || cardResponse.error.code === "invalid_expiry_month_past" || cardResponse.error.code === "incomplete_expiry") {
                        self.state.card_error.expiry = true;
                        self.state.card_error.show = true;
                        //self.state.card_error.message = cardResponse.error.message;
                    } else if (cardResponse.error.code === "incomplete_cvc" || cardResponse.error.code === "invalid_cvc") {
                        self.state.card_error.cvc = true;
                        self.state.card_error.show = true;
                        //self.state.card_error.message = cardResponse.error.message;
                    }
                    self.setState({isLoading: false, card_error: self.state.card_error});
                }
            })
        }

        function pollForSourceStatus(SOURCE_ID, CLIENT_SECRET, three_d_secure) {
            Stripe.retrieveSource({id: SOURCE_ID, client_secret: CLIENT_SECRET}).then(function (result) {
                var source = result.source;
                if (source.status === 'chargeable') {
                    self.setState({payment_modal: false, isLoading: true}, () => {
                        createCampaign(source.id, three_d_secure);
                    });
                } else if (source.status === 'pending') {
                    setTimeout(pollForSourceStatus(SOURCE_ID, CLIENT_SECRET, three_d_secure), 1000);
                } else if (source.status === 'canceled' || source.status === 'consumed' || source.status === 'failed') {
                    this.setState({isLoading: false});
                } else {
                    this.setState({isLoading: false});
                }
            });
        }

        function createCampaign(id, three_d_secure) {
            //UPDATE CAMPAIGN DATA
            let campaign = self.update.campaign(id);
            const formData = new FormData();
            for (let key in campaign) {
                formData.append(key, campaign[key]);
            }
            //SET IF CARD IS A 3D SECURE CARD OR NOT
            if (three_d_secure) {
                formData.append("source_type", "three_d_secure_validated");
            } else {
                formData.append("source_type", "card");
            }
            //CHECK IF USER IS LOGGED IN
            if (self.state.logged_in) {
                //CREATE CAMPAIGN
                self.functions.createCampaignPay(formData);
            } else {
                //CREATE USER OBJECT
                let user = {email: self.state.email, password: self.state.password, lang: langRegister.lang()};
                //CALL API TO CREATE USER
                dataRegister.signUp(salesChannelRegister.get("market"), user).then((response) => {
                    if (!response.errors) {
                        //UPDATE USER DATA
                        userRegister.set(response);
                        self.update.user();
                        //PAY NOW
                        self.functions.createCampaignPay(formData);
                    } else {
                        //SIGNUP ERROR
                        self.setState({isLoading: false}, () => {
                            console.log(response.errors)
                        });
                    }
                }, (error) => {
                    //CREATE USER SIGNUP API ERROR
                    if (error.status === 400) {
                        self.setState({user_error: true, isLoading: false}, () => {
                            console.log(error);
                        });
                    } else {
                        self.setState({system_error: true, isLoading: false}, () => {
                            console.log(error);
                        });
                    }
                });
            }
        }
    }

    _selectCountry(option) {
        this.setState({country: option, search: option.dialCode});
    }

    validators = {
        email: (value) => {
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(String(value).toLowerCase());
        },
        website: (value) => {
            try {
                return value.length > 2;
            }catch (e) {
                return false
            }
            //var re = /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9äöåøæØÆÅ\-]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/;
            //return re.test(String(value).toLowerCase());
        },
        phone: (value) => {
            var re = /^[0-9 +]+$/;
            return re.test(String(value).toLowerCase()) && value.length > 5;
        }
    };

    calculate = {
        exclVat: () => {
            if (this.state.budget && this.state.channels) {
                let budget = 0;
                for (let key in this.state.budget) {
                    if (this.state.budget[key] && this.state.channels[key].selected) {
                        budget = budget + this.state.budget[key].spend;
                    }
                }
                // IF FIXED FEE
                if (this.state.service_fee_fixed) {
                    budget = budget + this.calculate.fixedFee();
                }
                //IF PERCENTAGE SERVICE FEE
                if (this.state.service_fee_percentage) {
                    budget = budget + this.calculate.percentageFee();
                }
                //IF COMMISSION
                if (!this.state.service_fee_percentage && !this.state.service_fee_fixed && this.state.lockin) {
                    budget = budget * this.state.lockin_plan.months;
                }
                return budget;
            }
        },
        partialBudget: () => {
            if (this.state.budget && this.state.channels) {
                let budget = 0;
                for (let key in this.state.budget) {
                    if (this.state.budget[key] && this.state.channels[key].selected) {
                        budget = budget + this.state.budget[key].spend;
                    }
                }
                // IF FIXED FEE
                if (this.state.service_fee_fixed) {
                    budget = budget + this.calculate.fixedFee();
                }
                //IF PERCENTAGE SERVICE FEE
                if (this.state.service_fee_percentage) {
                    budget = budget + this.calculate.percentageFee();
                }
                //IF COMMISSION
                if (!this.state.service_fee_percentage && !this.state.service_fee_fixed && this.state.lockin) {
                    budget = budget * this.state.lockin_plan.months;
                }
                //IF LOCKIN
                if (this.state.lockin) {
                    budget = budget - this.calculate.discount();
                }
                //IF DISCOUNT
                if (this.state.discount) {
                    budget = budget - this.state.discount;
                }
                //IF VAT
                if (this.state.vat) {
                    budget = budget + this.calculate.vat();
                }
                return budget;
            }
        },
        fixedFee: () => {
            if (this.state.lockin && this.state.lockin_plan) {
                return this.state.service_fee_fixed * this.state.lockin_plan.months;
            } else {
                return this.state.service_fee_fixed
            }
        },
        percentageFee: () => {
            if (this.state.budget && this.state.channels) {
                let budget = 0;
                for (let key in this.state.budget) {
                    if (this.state.budget[key] && this.state.channels[key].selected) {
                        budget = budget + this.state.budget[key].spend;
                    }
                }
                if (this.state.lockin && this.state.lockin_plan) {
                    return (budget * (this.state.service_fee_percentage / 100)) * this.state.lockin_plan.months;
                } else {
                    return budget * (this.state.service_fee_percentage / 100);
                }
            }
        },
        discount: () => {
            if (this.state.lockin_plan) {
                let budget = 0;
                for (let key in this.state.budget) {
                    if (this.state.budget[key] && this.state.channels[key].selected) {
                        budget = budget + this.state.budget[key].spend;
                    }
                }
                if (this.state.service_fee_fixed) {
                    return this.state.service_fee_fixed * this.state.lockin_plan.free_months;
                }
                else if (this.state.service_fee_percentage) {
                    return (budget * (this.state.service_fee_percentage / 100)) * this.state.lockin_plan.free_months;
                } else {
                    return budget * this.state.lockin_plan.free_months;
                }
            }
        },
        vat: () => {
            if (this.state.budget && this.state.channels) {
                let budget = 0;
                for (let key in this.state.budget) {
                    if (this.state.budget[key] && this.state.channels[key].selected) {
                        budget = budget + this.state.budget[key].spend;
                    }
                }
                // IF FIXED FEE
                if (this.state.service_fee_fixed) {
                    budget = budget + this.calculate.fixedFee();
                }
                //IF PERCENTAGE SERVICE FEE
                if (this.state.service_fee_percentage) {
                    budget = budget + this.calculate.percentageFee();
                }
                //IF COMMISSION
                if (!this.state.service_fee_percentage && !this.state.service_fee_fixed && this.state.lockin) {
                    budget = budget * this.state.lockin_plan.months;
                }
                //IF LOCKIN
                if (this.state.lockin) {
                    budget = budget - this.calculate.discount();
                }

                //IF DISCOUNT
                if (this.state.discount && !this.state.lockin) {
                    budget = budget - +this.state.discount;
                }

                return budget * (this.state.vat / 100);
            }
        }
    };

    renders = {
        modal: () => {
            if (this.state.payment_modal) {
                return (
                    <div className={Styles.paymentModalContainer}>
                        <div className={Styles.paymentModalContainerInner}>
                            <div onClick={() => this.setState({payment_modal: false})}
                                 className={Styles.paymentModalContainerInnerClose}>
                                <img className={Styles.paymentModalContainerInnerCloseIcon}
                                     src={require("../../assets/images/close_icon.svg")}/>
                            </div>
                            <div className={Styles.paymentModalContainerInnerFrame}>
                                <div id="iframe-payment"/>
                            </div>
                            <BeatLoader size={30} color={'#41CBC7'} loading={true}/>
                        </div>
                    </div>
                )
            }
        },
        previewLandingPage: () => {
            return (
                <div className={Styles.inputDivider}>
                    <div className={Styles.inputDividerItem}>
                        <div onClick={() => this.functions.reviewLanding()}
                             className={cx(Styles.button, Styles.buttonBlack)}>
                            {this.parsers.text("item_43")}
                        </div>
                    </div>
                </div>
            )
        },
        previewAds: (channel) => {
            let cart = cartRegister.get();
            try {
                let exist = false;
                for (let key in cart.channels) {
                    if (channel === key && cart.channels[key].selected) {
                        exist = true;
                        break;
                    }
                }
                return exist
            } catch (e) {

            }
        },
        autocomplete: (value) => {
            try {
                if (!this.state.autocomplete_search) {
                    return value
                }
                return value.replace(new RegExp(this.state.autocomplete_search, "gi"), match => {
                    return '<bold>' + match + '</bold>';
                });
            } catch (e) {
                return value
            }
        },
        facebookPermission: () => {
            try {
                return this.state.user.show_fb_button;
            }catch (e) {
                return false;
            }
        },
        saleschanneldemo: () => {
            try {
                return salesChannelRegister.get('name') === 'saleschanneldemo';
            }catch (e) {
                return false;
            }
        },
        googleMybusiness: () => {
            try {
                return salesChannelRegister.get('name') === 'adc';
            }catch (e) {
                return false
            }
        }
    };

    parsers = {
        number: (value) => {
            try {
                value = Math.round(value * 100) / 100;
                return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
            } catch (e) {
                return (0)
            }
        },
        text: (value) => {
            return langRegister.get("signup-payment", value);
        }
    };

    render() {
        return (
            <div>
                {
                    this.state.coupon_modal &&
                    <ModalCoupon setModal={this.functions.setCouponModal}/>
                }
                {
                    this.renders.modal()
                }
                <HeaderSignupTwo history={this.props.history} props={this.props} step={5}/>
                {
                    this.state.channels && this.state.budget && this.state.currency && !this.state.system_error &&
                    <div className={Styles.container}>
                        <div className={Styles.title}>
                            <span
                                className={Styles.bold}>{this.parsers.text("item_3")}</span>{this.parsers.text("item_4")}
                        </div>
                        {
                            !this.state.register && !this.state.logged_in &&
                            <div className={Styles.subtitle}>
                                {this.parsers.text("item_1")}<span
                                className={cx(Styles.bold, Styles.link)}
                                onClick={() => {
                                    try {
                                        this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/" + salesChannelRegister.get('name') + "/login" + "?from_path=" + this.props.location.pathname);
                                    } catch (e) {
                                        this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/" + salesChannelRegister.get('name') + "/login");
                                    }
                                }
                                }>{this.parsers.text("item_2")}</span>
                            </div>
                        }
                        {
                            this.state.register && !this.state.logged_in &&
                            <div className={Styles.subtitle}>
                                {this.parsers.text("item_23")}<span
                                className={cx(Styles.bold)}>{this.parsers.text("item_24")}</span>
                            </div>
                        }

                        {
                            !this.state.register && !this.state.logged_in &&
                            <div>
                                <div className={cx(Styles.itemHeader, Styles.itemHeaderNotLoggedIn)}>
                                    {this.parsers.text("item_5")}
                                </div>
                                <div className={Styles.inputDivider}>
                                    <div className={Styles.inputDividerItem}>
                                        <input
                                            type="email"
                                            value={this.state.email}
                                            onChange={(event) => this.setState({email: event.target.value.toLowerCase()})}
                                            className={Styles.input}
                                            placeholder={this.parsers.text("item_8")}
                                        />
                                        {
                                            ((this.state.form_validation.email && !this.validators.email(this.state.email)) || this.state.user_error) &&
                                            <div className={Styles.inputError}/>
                                        }
                                    </div>
                                </div>
                                <div className={Styles.inputDivider}>
                                    <div className={Styles.inputDividerItem}>
                                        <input
                                            value={this.state.password}
                                            onChange={(event) => this.setState({password: event.target.value})}
                                            className={Styles.input}
                                            type={"password"}
                                            placeholder={this.parsers.text("item_9")}
                                        />
                                        {
                                            ((this.state.form_validation.password && this.state.password === "") || this.state.user_error) &&
                                            <div className={Styles.inputError}/>
                                        }
                                    </div>
                                </div>
                                <div onClick={() => this.functions.createUser()} className={Styles.loginButton}>
                                    {
                                        !this.state.register_loader &&
                                        this.parsers.text("item_64")
                                    }
                                    {
                                        this.state.register_loader &&
                                        <BeatLoader size={9} color={'#ffffff'} loading={true}/>
                                    }
                                </div>
                                {
                                    !this.state.logged_in &&
                                    <div
                                        onClick={() => this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/" + salesChannelRegister.get('name') + "/signup/checkout")}
                                        className={Styles.backButton}>
                                        {this.parsers.text("item_26")}
                                    </div>
                                }
                            </div>
                        }

                        <div className={cx(Styles.paymentStep,
                            {
                                [Styles.paymentStepNotLoggedIn]: !this.state.logged_in
                            })}>
                            {
                                !this.state.logged_in &&
                                <div className={Styles.paymentStepBlock}></div>
                            }
                            <div className={Styles.itemHeader}>
                                {
                                    !this.state.logged_in &&
                                    <div className={Styles.itemHeaderText}>
                                        {this.parsers.text("item_10")}
                                    </div>
                                }
                                {
                                    this.state.logged_in &&
                                    <div className={Styles.itemHeaderText}>
                                        {this.parsers.text("item_10")}
                                        <img className={Styles.itemHeaderBubble} src={require("../../assets/images/bubble_right.png")}/>
                                        <img className={Styles.itemHeaderBubbleMobile} src={require("../../assets/images/bubble_right_mobile.png")}/>
                                        <div className={Styles.itemHeaderBubbleText}>
                                            {this.parsers.text("item_30")}
                                        </div>
                                    </div>
                                }
                            </div>
                            <div className={Styles.inputDivider}>
                                <div className={cx(Styles.inputDividerItem)}>
                                    <input
                                        disabled={true}
                                        maxLength={23}
                                        value={this.state.company_name}
                                        onChange={(event) => {
                                            String.prototype.allReplace = function (obj) {
                                                var retStr = this;
                                                for (var x in obj) {
                                                    try {
                                                        retStr = retStr.replace(new RegExp(x, 'g'), obj[x]);
                                                    } catch (e) {
                                                    }
                                                }
                                                return retStr;
                                            };
                                            let string = event.target.value.allReplace({
                                                '!': '',
                                                '&': '',
                                                ';': '',
                                                '_': '',
                                                '`': '',
                                                '+': '',
                                                '≈': '',
                                                '[': '',
                                                ']': '',
                                                '|': '',
                                                '§': '',
                                                '∞': '',
                                                '$': '',
                                                '£': '',
                                                '©': '',
                                                '#': '',
                                                '€': '',
                                                '%': '',
                                                '=': '',
                                                ')': '',
                                                '(': '',
                                                '/': '',
                                                '{': '',
                                                '}': ''
                                            });
                                            this.setState({company_name: string});
                                        }}
                                        className={cx(Styles.input, Styles.inputDividerItemDisabled)}
                                        placeholder={this.parsers.text("item_11")}
                                    />
                                    {
                                        this.state.form_validation.company_name && this.state.company_name === "" &&
                                        <div className={Styles.inputError}></div>
                                    }
                                </div>
                                {
                                    this.renders.googleMybusiness() &&
                                    <div className={Styles.inputDividerItem}>
                                        <div className={Styles.checkMarksContainerItem}>
                                            {
                                                !this.state.googleMybusiness &&
                                                <img onClick={() => this.setState({
                                                    googleMybusiness: true
                                                })}
                                                     src={require("../../assets/images/square_checkmark_two.svg")}
                                                     className={Styles.checkMarksContainerItemIcon}/>
                                            }
                                            {
                                                this.state.googleMybusiness &&
                                                <img onClick={() => this.setState({
                                                    googleMybusiness: false
                                                })}
                                                     src={require("../../assets/images/square_checkmark_active.svg")}
                                                     className={Styles.checkMarksContainerItemIcon}/>
                                            }
                                            <div className={Styles.checkMarksContainerItemText}>
                                                {"List me on Google My Business "}<span style={{fontFamily: 'ITCAvantGardeStd-Bold', color: '#CC5430'}}>349 AED</span>
                                            </div>
                                        </div>
                                    </div>
                                }
                            </div>
                            <div className={Styles.inputDivider}>
                                <div className={Styles.inputDividerItem}>
                                    <input
                                        value={this.state.website}
                                        onChange={(event) => this.setState({website: event.target.value})}
                                        className={cx(Styles.input,
                                            {
                                                [Styles.inputDisabled]: this.state.landingpage
                                            })}
                                        disabled={this.state.landingpage}
                                        placeholder={this.parsers.text("item_12")}
                                    />
                                    {
                                        ((this.state.form_validation.website && !this.state.landingpage && !this.validators.website(this.state.website)) || this.state.website_error) &&
                                        <div className={Styles.inputError}></div>
                                    }
                                </div>
                                <div className={Styles.inputDividerItem}>
                                    <div style={this.state.branding ? {cursor: "pointer"} : {cursor: "default"}} className={Styles.checkMarksContainerItem}>
                                        {
                                            this.state.landingpage && !this.state.branding &&
                                            <img
                                                 src={require("../../assets/images/checkmark-disabled.svg")}
                                                 className={Styles.checkMarksContainerItemIcon}/>
                                        }
                                        {
                                            !this.state.landingpage && this.state.branding &&
                                            <img onClick={() => this.functions.setLanding()}
                                                 src={require("../../assets/images/square_checkmark_two.svg")}
                                                 className={Styles.checkMarksContainerItemIcon}/>
                                        }
                                        {
                                            this.state.landingpage && this.state.branding &&
                                            <img onClick={() => this.functions.setLanding()}
                                                 src={require("../../assets/images/square_checkmark_active.svg")}
                                                 className={Styles.checkMarksContainerItemIcon}/>
                                        }
                                        <div className={Styles.checkMarksContainerItemText}>
                                            {this.parsers.text("item_13")}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {
                                this.state.landingpage &&
                                <div className={Styles.inputDivider}>
                                    <div className={Styles.inputDividerItem}>
                                        <input
                                            type={'text'}
                                            onFocus={() => {
                                                try {
                                                    this.setState({autocomplete_dropdown: true})
                                                } catch (e) {
                                                }
                                            }}
                                            onBlur={() => {
                                                try {
                                                    this.setState({autocomplete_dropdown: false})
                                                } catch (e) {
                                                }
                                            }}
                                            className={Styles.input}
                                            value={this.state.autocomplete_search}
                                            placeholder={this.parsers.text("item_31")}
                                            onChange={(event) => {
                                                try {
                                                    if (event.target.value) {
                                                        this.setState({autocomplete_search: event.target.value}, () => {
                                                            try {
                                                                if (this.state.autocomplete_search !== this.state.landing_address) {
                                                                    this.setState({
                                                                        lng: null,
                                                                        lat: null,
                                                                        landing_address: null
                                                                    });
                                                                }
                                                                if (this.state.autocomplete_search && this.state.autocomplete_search !== "") {
                                                                    this.setState({autocomplete_dropdown: true}, () => {
                                                                        let auto_this = this;
                                                                        this.autocomplete.getPlacePredictions({
                                                                            input: this.state.autocomplete_search,
                                                                            componentRestrictions: {country: salesChannelRegister.get('market')},
                                                                        }, function (predictions, status) {
                                                                            if (status === 'OK' && predictions && predictions.length > 0) {
                                                                                auto_this.setState({autocomplete_predictions: predictions});
                                                                            } else {
                                                                                auto_this.setState({
                                                                                    autocomplete_dropdown: false,
                                                                                    autocomplete_predictions: []
                                                                                })
                                                                            }
                                                                        });
                                                                    })
                                                                } else {
                                                                    this.setState({
                                                                        autocomplete_dropdown: false,
                                                                        autocomplete_predictions: []
                                                                    })
                                                                }
                                                            } catch (e) {
                                                                this.setState({
                                                                    autocomplete_dropdown: false,
                                                                    autocomplete_predictions: []
                                                                })
                                                            }
                                                        })
                                                    }
                                                } catch (e) {
                                                }
                                            }}
                                        />
                                        {
                                            this.state.autocomplete_dropdown && this.state.autocomplete_predictions.length > 0 &&
                                            <div className={Styles.inputDividerItemDropdown}>
                                                {
                                                    this.state.autocomplete_predictions.map((item) => {
                                                        return (
                                                            <div onMouseDown={() => {
                                                                let google_this = this;
                                                                try {
                                                                    this.geocoder.geocode({'placeId': item.place_id}, function (results, status) {
                                                                        if (status === 'OK' && results && results.length > 0) {
                                                                            try {
                                                                                if (results[0].geometry && item.description) {
                                                                                    google_this.setState({
                                                                                        lat: results[0].geometry.location.lat(),
                                                                                        lng: results[0].geometry.location.lng(),
                                                                                        autocomplete_search: item.description,
                                                                                        landing_address: item.description
                                                                                    });
                                                                                }
                                                                            } catch (e) {
                                                                            }
                                                                        } else {
                                                                        }
                                                                    });
                                                                } catch (e) {
                                                                }
                                                            }} className={Styles.inputDividerItemDropdownItem}>
                                                                <div
                                                                    dangerouslySetInnerHTML={{__html: this.renders.autocomplete(item.description)}}
                                                                    className={Styles.inputDividerItemDropdownItemText}></div>
                                                            </div>
                                                        )
                                                    })
                                                }
                                            </div>
                                        }
                                        {
                                            this.state.form_validation.landing_address && this.state.landingpage &&
                                            <div className={Styles.inputError}/>
                                        }
                                    </div>
                                </div>
                            }

                            {
                                this.state.landingpage &&
                                <div className={Styles.inputDivider}>
                                    <div className={Styles.inputDividerItem}>
                                        <input
                                            value={this.state.landing_email}
                                            onChange={(event) => this.setState({landing_email: event.target.value.toLowerCase()})}
                                            className={Styles.input}
                                            placeholder={this.parsers.text("item_32")}
                                            type={"email"}
                                        />
                                        {
                                            this.state.form_validation.landing_email && !this.validators.email(this.state.landing_email) && this.state.landingpage &&
                                            <div className={Styles.inputError}/>
                                        }
                                    </div>
                                </div>
                            }

                            {
                                this.state.landingpage &&
                                <div className={Styles.inputDivider}>
                                    <div className={Styles.inputDividerItem}>
                                        <input
                                            value={this.state.landing_website}
                                            onChange={(event) => this.setState({landing_website: event.target.value.toLowerCase()})}
                                            className={Styles.input}
                                            placeholder={this.parsers.text("item_73")}
                                            type={"website"}
                                        />
                                        {
                                            this.state.form_validation.landing_website && !this.validators.website(this.state.landing_website) && this.state.landingpage &&
                                            <div className={Styles.inputError}/>
                                        }
                                    </div>
                                </div>
                            }

                            <div className={Styles.inputDivider}>
                                <div className={Styles.inputDividerItem}>
                                    <div className={Styles.inputDividerItemInner}>
                                        <div className={Styles.inputDividerItemInnerDropdown}>
                                            <input
                                                placeholder={this.parsers.text("item_55")}
                                                type="tel"
                                                onFocus={() => this.setState({dropdown: true})}
                                                onBlur={() => this.setState({dropdown: false})}
                                                value={this.state.search}
                                                onChange={(event) => this.setState({search: event.target.value}, () => {
                                                    if (this.state.search !== this.state.country.dialCode) {
                                                        console.log(this.state.country.dialCode);
                                                        this.setState({country: {}});
                                                    }
                                                })}
                                                className={Styles.inputDividerItemInnerDropdownInput}
                                            />
                                            {
                                                this.state.dropdown && this.state.countries.filter((item) => {
                                                    return item.dialCode.toLowerCase().indexOf(this.state.search.toLowerCase()) !== -1
                                                }).length > 0 &&
                                                <div className={Styles.dropdownList}>
                                                    {
                                                        this.state.countries.filter((item) => {
                                                            return item.dialCode.toLowerCase().indexOf(this.state.search.toLowerCase()) !== -1
                                                        }).map((prop, key) => {
                                                            return (
                                                                <div key={key}
                                                                     onMouseDown={() => this._selectCountry(prop)}
                                                                     className={Styles.dropdownListItem}>
                                                                    {prop.dialCode}
                                                                </div>
                                                            )
                                                        })
                                                    }
                                                </div>
                                            }
                                            {
                                                this.state.form_validation.dialcode && !this.state.country.dialCode &&
                                                <div className={Styles.inputError}/>
                                            }
                                        </div>
                                        <div className={Styles.inputDividerItemInnerInput}>
                                            <InputMask className={cx(Styles.input)}
                                                       type="tel"
                                                       placeholder={this.parsers.text("item_21") + (this.state.landingpage?"*":(!this.state.inhouse)?"*":"")}
                                                       maskChar={null}
                                                       mask={"9999999999999999"}
                                                       value={this.state.phone}
                                                       onChange={(event) => this.setState({phone: event.target.value.trim()})}/>
                                            {
                                                this.state.form_validation.phone && this.state.error &&
                                                <div className={Styles.inputError}/>
                                            }
                                        </div>
                                    </div>
                                </div>
                                {
                                    this.state.landingpage &&
                                    <div className={Styles.inputDividerItem}>
                                        <div className={Styles.checkMarksContainerItem}>
                                            {
                                                !this.state.whatsapp &&
                                                <img onClick={() => this.setState({whatsapp: true})}
                                                     src={require("../../assets/images/square_checkmark_two.svg")}
                                                     className={Styles.checkMarksContainerItemIcon}/>
                                            }
                                            {
                                                this.state.whatsapp &&
                                                <img onClick={() => this.setState({whatsapp: false})}
                                                     src={require("../../assets/images/square_checkmark_active.svg")}
                                                     className={Styles.checkMarksContainerItemIcon}/>
                                            }
                                            <img className={Styles.checkMarksContainerItemWhatsapp}
                                                 src={require("../../assets/images/whatsapp.png")}/>
                                        </div>
                                    </div>
                                }
                            </div>
                            {
                                this.state.landingpage &&
                                this.renders.previewLandingPage()
                            }

                            <div className={Styles.itemHeader}>
                                <div onClick={() => this.setState({show_two: !this.state.show_two})} className={Styles.itemHeaderInner}>
                                    <div className={Styles.itemHeaderInnerLeft}>
                                        {this.parsers.text("item_59")}
                                    </div>
                                    <img className={
                                        cx(Styles.itemHeaderArrow,
                                            {
                                                [Styles.itemHeaderArrowActive]: this.state.show_two,
                                            })
                                    } src={require("../../assets/images/arrow-icon-grey.svg")}/>
                                </div>
                            </div>
                            <div className={cx(Styles.inputDivider, Styles.inputDividerOne,
                                {
                                    [Styles.inputDividerOneOpen]: this.state.show_two,
                                    [Styles.inputDividerSecondOpen]: this.state.show_two
                                })}>
                                <div className={Styles.iconsContainer}>
                                    {
                                        this.renders.previewAds('google') &&
                                        <div onClick={() => this._placement('google')}
                                             className={Styles.iconsContainerItem}>
                                            <img className={Styles.iconsContainerItemGoogle}
                                                 src={require('../../assets/images/google_logo_icon.svg')}/>
                                        </div>
                                    }
                                    {
                                        this.renders.previewAds('facebook') &&
                                        <div onClick={() => this._placement('facebook')}
                                             className={Styles.iconsContainerItem}>
                                            <img className={Styles.iconsContainerItemFacebook}
                                                 src={require('../../assets/images/facebook_logo_icon.svg')}/>
                                        </div>
                                    }
                                    {
                                        this.renders.previewAds('bing') &&
                                        <div onClick={() => this._placement('bing')} className={Styles.iconsContainerItem}>
                                            <img className={Styles.iconsContainerItemBing}
                                                 src={require('../../assets/images/bing_logo_icon.svg')}/>
                                        </div>
                                    }
                                    {
                                        this.renders.previewAds('instagram') &&
                                        <div onClick={() => this._placement('instagram')}
                                             className={Styles.iconsContainerItem}>
                                            <img className={Styles.iconsContainerItemInstagram}
                                                 src={require('../../assets/images/instagram_logo_icon.svg')}/>
                                        </div>
                                    }
                                </div>
                            </div>

                            {
                                this.state.reseller &&
                                <div>
                                    <div className={Styles.itemHeader}>
                                        <div  onClick={() => this.setState({show_one: !this.state.show_one})} className={Styles.itemHeaderInner}>
                                            <div className={Styles.itemHeaderInnerLeft}>
                                                {this.parsers.text("item_38")}
                                            </div>
                                            <img className={
                                                cx(Styles.itemHeaderArrow,
                                                    {
                                                        [Styles.itemHeaderArrowActive]: this.state.show_one,
                                                    })
                                            } src={require("../../assets/images/arrow-icon-grey.svg")}/>
                                        </div>
                                    </div>

                                    <div className={cx(Styles.inputDividerTwo,
                                        {
                                            [Styles.inputDividerTwoOpen]: this.state.show_one,
                                            [Styles.inputDividerTwoOpenRadio]: this.state.show_one && this.state.redirect,
                                            [Styles.inputDividerTwoOpenRadioInputs]: this.state.show_one && this.state.redirect && this.state.greetings_invoice && this.state.user_name && this.state.user_image,
                                            [Styles.inputDividerTwoOpenRadioInputsNoImage]: this.state.show_one && this.state.redirect && this.state.greetings_invoice && this.state.user_name && !this.state.user_image
                                        })}>
                                        <div className={cx(Styles.inputDivider)}>
                                            <div className={Styles.inputDividerItem}>
                                                <input
                                                    value={this.state.redirect ? this.state.redirect_email : this.state.user_email}
                                                    onChange={(event) => this.setState({redirect_email: event.target.value.toLowerCase()})}
                                                    className={cx(Styles.input,
                                                        {
                                                            [Styles.inputDisabled]: !this.state.redirect
                                                        })}
                                                    disabled={!this.state.redirect}
                                                    placeholder={this.parsers.text("item_40")}
                                                />
                                                {
                                                    this.state.form_validation.redirect_email && this.state.redirect && !this.validators.email(this.state.redirect_email) &&
                                                    <div className={Styles.inputError}></div>
                                                }
                                            </div>
                                            <div className={Styles.inputDividerItem}>
                                                <div className={Styles.checkMarksContainerItem}>
                                                    {
                                                        !this.state.redirect &&
                                                        <img onClick={() => this.setState({redirect: true})}
                                                             src={require("../../assets/images/square_checkmark_two.svg")}
                                                             className={Styles.checkMarksContainerItemIcon}/>
                                                    }
                                                    {
                                                        this.state.redirect &&
                                                        <img onClick={() => this.setState({redirect: false, greetings_invoice: false})}
                                                             src={require("../../assets/images/square_checkmark_active.svg")}
                                                             className={Styles.checkMarksContainerItemIcon}/>
                                                    }
                                                    <div className={Styles.checkMarksContainerItemText}>
                                                        {this.parsers.text("item_39")}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        {
                                            this.state.redirect &&
                                            <div className={cx(Styles.greetingsContainer,
                                                {
                                                    [Styles.greetingsContainerDisabled]: this.state.pay_now
                                                })}>
                                                {
                                                    this.state.pay_now &&
                                                    <div className={Styles.paymentStepBlock}></div>
                                                }
                                                {
                                                    <div className={Styles.radioButtonContainer}>
                                                        <div onClick={() => {this.setState({greetings_invoice: true});}} className={Styles.radioButton}>
                                                            <div className={
                                                                cx(Styles.radioButtonCircle,
                                                                    {
                                                                        [Styles.radioButtonCircleActive]: this.state.greetings_invoice,
                                                                    })
                                                            }>
                                                                {
                                                                    this.state.greetings_invoice &&
                                                                    <div className={Styles.radioButtonCircleActiveCirlce}/>
                                                                }
                                                            </div>
                                                            <div className={Styles.radioButtonTitle}>
                                                                {this.parsers.text("item_65")}
                                                            </div>
                                                        </div>
                                                        <div onClick={() => {this.setState({greetings_invoice: false});}}className={Styles.radioButton}>
                                                            <div className={
                                                                cx(Styles.radioButtonCircle,
                                                                    {
                                                                        [Styles.radioButtonCircleActive]: !this.state.greetings_invoice,
                                                                    })
                                                            }>
                                                                {
                                                                    !this.state.greetings_invoice &&
                                                                    <div className={Styles.radioButtonCircleActiveCirlce}/>
                                                                }
                                                            </div>
                                                            <div className={Styles.radioButtonTitle}>
                                                                {this.parsers.text("item_66")}
                                                            </div>
                                                        </div>
                                                    </div>
                                                }
                                                {
                                                    this.state.greetings_invoice && !this.state.pay_now && this.state.user_name &&
                                                    <div className={cx(Styles.inputDivider)}>
                                                        <div className={Styles.inputDividerItem}>
                                                            <input
                                                                value={this.state.user_name}
                                                                className={cx(Styles.input,
                                                                    {
                                                                        [Styles.inputDisabled]: true
                                                                    })}
                                                                disabled={true}
                                                                placeholder={this.parsers.text("item_68")}
                                                            />
                                                        </div>
                                                        {
                                                            this.state.user_image &&
                                                            <div className={Styles.inputDividerItem}>
                                                                <div className={Styles.checkMarksContainerItem}>
                                                                    {
                                                                        !this.state.greetings_invoice_profileimage &&
                                                                        <img onClick={() => this.setState({greetings_invoice_profileimage: true})}
                                                                             src={require("../../assets/images/square_checkmark_two.svg")}
                                                                             className={Styles.checkMarksContainerItemIcon}/>
                                                                    }
                                                                    {
                                                                        this.state.greetings_invoice_profileimage &&
                                                                        <img onClick={() => this.setState({greetings_invoice_profileimage: false})}
                                                                             src={require("../../assets/images/square_checkmark_active.svg")}
                                                                             className={Styles.checkMarksContainerItemIcon}/>
                                                                    }
                                                                    <div className={Styles.checkMarksContainerItemText}>
                                                                        {this.parsers.text("item_67")}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        }
                                                    </div>
                                                }
                                                {
                                                    this.state.greetings_invoice && !this.state.pay_now && false &&
                                                    <div className={cx(Styles.inputDivider)}>
                                                        <div className={Styles.inputDividerItem}>
                                                            <input
                                                                value={this.state.user_email}
                                                                className={cx(Styles.input,
                                                                    {
                                                                        [Styles.inputDisabled]: true
                                                                    })}
                                                                disabled={true}
                                                                placeholder={this.parsers.text("item_71")}
                                                            />
                                                        </div>
                                                        <div className={Styles.inputDividerItem}>
                                                            <div className={Styles.checkMarksContainerItem}>
                                                                {
                                                                    !this.state.greetings_incvoice_email &&
                                                                    <img onClick={() => this.setState({greetings_incvoice_email: true})}
                                                                         src={require("../../assets/images/square_checkmark_two.svg")}
                                                                         className={Styles.checkMarksContainerItemIcon}/>
                                                                }
                                                                {
                                                                    this.state.greetings_incvoice_email &&
                                                                    <img onClick={() => this.setState({greetings_incvoice_email: false})}
                                                                         src={require("../../assets/images/square_checkmark_active.svg")}
                                                                         className={Styles.checkMarksContainerItemIcon}/>
                                                                }
                                                                <div className={Styles.checkMarksContainerItemText}>
                                                                    {this.parsers.text("item_69")}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                }
                                                {
                                                    this.state.greetings_invoice && !this.state.pay_now && false &&
                                                    <div className={cx(Styles.inputDivider)}>
                                                        <div className={Styles.inputDividerItem}>
                                                            <input
                                                                value={ this.state.user_phone}
                                                                className={cx(Styles.input,
                                                                    {
                                                                        [Styles.inputDisabled]: true
                                                                    })}
                                                                disabled={true}
                                                                placeholder={this.parsers.text("item_72")}
                                                            />
                                                        </div>
                                                        <div className={Styles.inputDividerItem}>
                                                            <div className={Styles.checkMarksContainerItem}>
                                                                {
                                                                    !this.state.greetings_incvoice_phone &&
                                                                    <img onClick={() => this.setState({greetings_incvoice_phone: true})}
                                                                         src={require("../../assets/images/square_checkmark_two.svg")}
                                                                         className={Styles.checkMarksContainerItemIcon}/>
                                                                }
                                                                {
                                                                    this.state.greetings_incvoice_phone &&
                                                                    <img onClick={() => this.setState({greetings_incvoice_phone: false})}
                                                                         src={require("../../assets/images/square_checkmark_active.svg")}
                                                                         className={Styles.checkMarksContainerItemIcon}/>
                                                                }
                                                                <div className={Styles.checkMarksContainerItemText}>
                                                                    {this.parsers.text("item_70")}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                }
                                            </div>
                                        }
                                    </div>
                                </div>
                            }


                            {
                                !this.state.lockin &&
                                <div className={Styles.itemHeader}>
                                    <div onClick={() => this.setState({show_three: !this.state.show_three})} className={Styles.itemHeaderInner}>
                                        <div className={Styles.itemHeaderInnerLeft}>
                                            {this.parsers.text("item_27")}
                                        </div>
                                        <img className={
                                            cx(Styles.itemHeaderArrow,
                                                {
                                                    [Styles.itemHeaderArrowActive]: this.state.show_three,
                                                })
                                        } src={require("../../assets/images/arrow-icon-grey.svg")}/>
                                    </div>
                                </div>
                            }
                            {
                                !this.state.lockin &&
                                <div className={cx(Styles.inputDivider, Styles.inputDividerOne,
                                    {
                                        [Styles.inputDividerOneOpen]: this.state.show_three
                                    })}>
                                    <div className={Styles.inputDividerItem}>
                                        <input
                                            value={this.state.coupon}
                                            onChange={(event) => this.setState({coupon: event.target.value})}
                                            className={Styles.input}
                                            disabled={this.state.isCouponLoading || this.state.coupon_success}
                                            placeholder={this.parsers.text("item_42")}
                                        />
                                    </div>
                                    <div className={Styles.inputDividerItemCoupon}>
                                        <div onClick={() => {
                                            if (this.state.coupon_success) {
                                                this.setState({discount: null, coupon_success: false, coupon: ""})
                                            } else {
                                                this.functions.checkCoupon()
                                            }
                                        }} className={
                                            cx(Styles.couponButton,
                                                {
                                                    [Styles.couponButtonSuccess]: this.state.coupon_success,
                                                })
                                        }>
                                            {
                                                !this.state.isCouponLoading && !this.state.coupon_success &&
                                                <span>{this.parsers.text("item_28")}</span>
                                            }
                                            {
                                                !this.state.isCouponLoading && this.state.coupon_success &&
                                                <span>{this.parsers.text("item_60")}{" "}{this.state.discount}{" "}{this.state.currency}</span>
                                            }
                                            {
                                                this.state.isCouponLoading &&
                                                <BeatLoader size={10} color={'#ffffff'} loading={true}/>
                                            }
                                        </div>
                                    </div>
                                </div>
                            }
                            {
                                (this.renders.previewAds('facebook') || this.renders.previewAds('instagram')) && this.state.logged_in && this.renders.saleschanneldemo() &&
                                <div className={Styles.itemHeader}>
                                    {this.parsers.text("item_61")}
                                </div>
                            }
                            {
                                (this.renders.previewAds('facebook') || this.renders.previewAds('instagram')) && this.state.logged_in && this.renders.saleschanneldemo() &&
                                <div className={cx(Styles.inputDivider)}>
                                    <div className={Styles.iconsContainer}>
                                        {
                                            (this.renders.previewAds('facebook') || this.renders.previewAds('instagram')) &&
                                            <div
                                                onClick={() => {
                                                    if(this.state.pay_now){
                                                        this.functions.facebookLogin();
                                                    }
                                                }}
                                                className={
                                                cx(Styles.iconsContainerItemButton,
                                                    {
                                                        [Styles.iconsContainerItemButtonApproved]: !this.renders.facebookPermission(),
                                                        [Styles.iconsContainerItemButtonError]: this.state.form_validation.facebook_permission && this.renders.facebookPermission(),
                                                        [Styles.iconsContainerItemButtonDisabled]: !this.state.pay_now,
                                                    })
                                            }>
                                                <div className={
                                                    cx(Styles.iconsContainerItem,
                                                        {
                                                            [Styles.iconsContainerItemApproved]: !this.renders.facebookPermission(),
                                                            [Styles.iconsContainerItemError]: this.state.form_validation.facebook_permission && this.renders.facebookPermission(),
                                                        })
                                                }>
                                                    {
                                                        this.renders.previewAds('facebook') &&
                                                        <img className={Styles.iconsContainerItemFacebook} src={require('../../assets/images/facebook_logo_icon.svg')}/>
                                                    }
                                                    {
                                                        !this.renders.previewAds('facebook') && this.renders.previewAds('instagram') &&
                                                        <img className={Styles.iconsContainerItemInstagram} src={require('../../assets/images/instagram_logo_icon.svg')}/>
                                                    }
                                                </div>
                                                {
                                                    this.renders.facebookPermission() &&
                                                    <div className={
                                                        cx(Styles.iconsContainerItemButtonText,
                                                            {
                                                                [Styles.iconsContainerItemButtonTextError]: this.state.form_validation.facebook_permission && this.renders.facebookPermission(),
                                                            })
                                                    }>
                                                        {this.parsers.text("item_62")}
                                                    </div>
                                                }
                                                {
                                                    !this.renders.facebookPermission() &&
                                                    <div className={cx(Styles.iconsContainerItemButtonText, Styles.iconsContainerItemButtonTextApproved)}>
                                                        {this.parsers.text("item_63")}
                                                    </div>
                                                }
                                            </div>
                                        }
                                    </div>
                                </div>
                            }

                            <div className={Styles.itemHeaderPayment}>
                                <div className={Styles.itemHeaderPaymentTitle}>
                                    {this.parsers.text("item_15")}
                                    {
                                        dataRegister.api.primehit === "https://api.devprimehit.com/v1" &&
                                        <span className={Styles.itemHeaderPaymentTitleWarning}>{" "}(demo)</span>
                                    }
                                </div>
                                <img src={require("../../assets/images/AB_payment_verified.png")}
                                     className={Styles.itemHeaderPaymentVerified}/>
                                <img src={require("../../assets/images/stripe_logo.svg")}
                                     className={Styles.itemHeaderPaymentIcon}/>
                            </div>

                            {
                                this.state.reseller &&
                                <div className={Styles.radioButtonContainer}>
                                    <div onClick={() => {
                                        window.cardNumber.update({disabled: false});
                                        window.cardExpiry.update({disabled: false});
                                        window.cardCvc.update({disabled: false});
                                        this.setState({pay_now: true, greetings_invoice: false});
                                    }} className={Styles.radioButton}>
                                        <div className={
                                            cx(Styles.radioButtonCircle,
                                                {
                                                    [Styles.radioButtonCircleActive]: this.state.pay_now,
                                                })
                                        }>
                                            {
                                                this.state.pay_now &&
                                                <div className={Styles.radioButtonCircleActiveCirlce}/>
                                            }
                                        </div>
                                        <div className={Styles.radioButtonTitle}>
                                            {this.parsers.text("item_35")}
                                        </div>
                                    </div>
                                    <div onClick={() => {
                                        window.cardNumber.update({disabled: true});
                                        window.cardExpiry.update({disabled: true});
                                        window.cardCvc.update({disabled: true});
                                        window.cardNumber.clear();
                                        window.cardExpiry.clear();
                                        window.cardCvc.clear();
                                        this.state.card_error.number = false;
                                        this.state.card_error.expiry = false;
                                        this.state.card_error.cvc = false;
                                        this.state.card_error.message = "";
                                        this.state.card_error.show = false;
                                        this.setState({pay_now: false, card_error: this.state.card_error});
                                    }} className={Styles.radioButton}>
                                        <div className={
                                            cx(Styles.radioButtonCircle,
                                                {
                                                    [Styles.radioButtonCircleActive]: !this.state.pay_now,
                                                })
                                        }>
                                            {
                                                !this.state.pay_now &&
                                                <div className={Styles.radioButtonCircleActiveCirlce}/>
                                            }
                                        </div>
                                        <div className={Styles.radioButtonTitle}>
                                            {this.parsers.text("item_36")}
                                        </div>
                                    </div>
                                </div>
                            }
                            {
                                <div className={
                                    cx(
                                        {
                                            [Styles.paymentOverlayPayNow]: !this.state.pay_now,
                                        })
                                }>
                                    <div className={
                                        cx(Styles.inputDivider, Styles.inputDividerIconsTop,
                                            {
                                                [Styles.inputDividerExtraSpace]: !this.state.reseller,
                                            })
                                    }>
                                        <div className={cx(Styles.inputDividerItem, Styles.inputDividerItemCardsFirst)}>
                                            <div className={Styles.paymentCards}>
                                                <img className={Styles.paymentCardsItem}
                                                     src={require("../../assets/images/AB_payment_cards.png")}/>
                                            </div>
                                        </div>
                                    </div>
                                    <div className={cx(Styles.inputDivider, Styles.inputDividerIconsTop)}>
                                        <div className={cx(Styles.inputDividerItem, Styles.inputDividerItemCards)}>
                                            <div className={cx(Styles.input)} id={"card-number"}/>
                                            {
                                                this.state.card_error.number &&
                                                <div className={Styles.inputError}/>
                                            }
                                        </div>
                                    </div>
                                    <div className={Styles.inputDivider}>
                                        <div className={cx(Styles.inputDividerItemPaymentContainer)}>
                                            <div className={cx(Styles.inputDividerItemPaymentExpiry)}>
                                                <div className={cx(Styles.input)} id={"card-expiry"}></div>
                                                {
                                                    this.state.card_error.expiry &&
                                                    <div className={Styles.inputError}/>
                                                }
                                            </div>
                                            <div className={Styles.inputDividerItemPayment}>
                                                <div className={cx(Styles.input)} id={"card-cvc"}></div>
                                                {
                                                    this.state.card_error.cvc &&
                                                    <div className={Styles.inputError}/>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            }
                            <div className={Styles.divider}/>
                            <div className={
                                cx(Styles.errorMessage,
                                    {
                                        [Styles.errorMessageActive]: this.state.error || this.state.card_error.cvc || this.state.card_error.number || this.state.card_error.month || this.state.card_error.year || this.state.website_error || this.state.card_error.show || this.state.user_error
                                    })
                            }>
                                {
                                    this.state.website_error &&
                                    this.parsers.text("item_56")
                                }
                                {
                                    this.state.card_error.show &&
                                    this.parsers.text("item_34")
                                }
                                {
                                    this.state.error === 401 &&
                                    this.parsers.text("item_33")
                                }
                                {
                                    this.state.error === 404 &&
                                    this.parsers.text("item_34")
                                }
                                {
                                    this.state.error && this.state.error !== 404 && this.state.error !== 401 &&
                                    this.parsers.text("item_34")
                                }
                                {
                                    this.state.user_error &&
                                    this.parsers.text("item_54")
                                }
                            </div>
                            {
                                !this.state.isLoading && this.state.logged_in &&
                                <div>
                                    <div onClick={() => this._payment()} className={Styles.button}>
                                        {
                                            this.state.pay_now &&
                                            <span>{this.parsers.text("item_20")}{" "}{this.parsers.number(this.calculate.partialBudget())}{" "}{this.state.currency.toLowerCase()}</span>
                                        }
                                        {
                                            !this.state.pay_now &&
                                            <span>{this.parsers.text("item_37")}</span>
                                        }
                                    </div>
                                </div>
                            }
                            {
                                this.state.logged_in &&
                                <div
                                    onClick={() => this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/" + salesChannelRegister.get('name') + "/signup/checkout")}
                                    className={Styles.backButton}>
                                    {this.parsers.text("item_26")}
                                </div>
                            }

                        </div>


                    </div>
                }
                {
                    this.state.isLoading &&
                    <div className={Styles.loader}>
                        <BeatLoader size={30} color={'#41CBC7'} loading={true}/>
                    </div>
                }
                {
                    !this.state.isLoading && this.state.system_error &&
                    <div className={Styles.loader}>
                        <ErrorHandler props={this.props}/>
                    </div>
                }
            </div>
        );
    }
}

export default SignupPayment;


// WEBPACK FOOTER //
// ./src/pages/signup-payment/component.js